import { viewingGuide } from "@/mocks/content";
import SectionHeading from "./SectionHeading";

export default function ViewingGuide() {
  return (
    <section id="guide" className="bg-secondary-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="观影指南"
          title="四步选出今晚真正想看的那部"
          description="选片其实有方法。把需求、评分、时间和避坑这四件事理清楚，你会发现自己找片的速度快很多。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2">
          {viewingGuide.map((item, index) => (
            <article
              key={item.title}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <span className="font-heading text-sm font-bold text-secondary-700">
                  0{index + 1}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">
                {item.description}
              </p>
              <ul className="mt-4 space-y-2 border-t border-background-200 pt-4">
                {item.points.map((point) => (
                  <li
                    key={point}
                    className="flex items-start gap-2 font-label text-xs text-foreground-700"
                  >
                    <i className="ri-checkbox-circle-fill mt-0.5 text-sm text-accent-500"></i>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}